import * as Yup from "yup";
import {isEmptyString, isNullOrUndefined, patente, rut} from '../validators';

export * from './patente/patente';
export * from './rut/rut';
export * from './auth-utils';
export const compose = (...params) => params.reduce((prev, next) => (acc) => next(prev(acc)));

export const chileCurrency = (curr) => {
    return '$ ' + new Intl.NumberFormat('de-DE').format(curr);
    //Intl.NumberFormat('de-DE', {style: "currency", currency: "CLP"}).format(curr)
};

export const addStyle = (prop, value) => styles => {
    if (prop) {
        return styles + value;
    }
    return styles;
};

export const capitalize = (string) => {
    return string ? `${string[0].toUpperCase()}${string.slice(1)}` : string;
};

export const emptyFn = () => {
};

export const validateEmail = Yup.string()
    .max(100, "La cantidad máxima de caracteres es 100.")
    .required("El correo electrónico es requerido.")
    .test("email", "El correo electrónico no es válido.", value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(value?.trim()));

export const emailConfirm = (email, confirmEmail) => validateEmail.test("email-confirm", "Los campos de correo no coinciden.", () => !confirmEmail || email === confirmEmail);

// RUT juridico
export const validateLegalRut = Yup.string()
    .required("El RUT es requerido.")
    .test("legal-rut", "El RUT no es válido o no es un RUT de persona jurídica.", value => rut.checkLegalRut(value));

//RUT natural
export const validateNativeRut = Yup.string()
    .required("El RUT es requerido.")
    .test("native-rut", "El RUT no es válido o no es un RUT de persona natural.", value => rut.checkNativeRut(value));

//phone isValid
export const validateCountryPhone = Yup.string()
    .required("El teléfono es requerido.")
    .test("country-phone", "El RUT no es válido o no es un RUT de persona natural.", value => rut.checkNativeRut(value));

// Patente isValid
export const validatePatente = vehicle => Yup.string()
    .required("La Patente es requerida.")
    .test("patente", function (value) {
        return patente.verify(value, vehicle, this)
    });

export const validateRequired = (message) => Yup.string()
    .required(message)
    .max(100, "La cantidad máxima de caracteres es 100.");

Yup.addMethod(Yup.string, 'name', function yupName(errorMessage = '') {
    return this.test('name', errorMessage, function (value, config) {
        if (isNullOrUndefined(value) || value === '') return true;

        const regName = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
        if (!regName.test(value.trim())) {
            return this.createError({path: config.path, message: errorMessage});
        }

        return true;
    });
});

Yup.addMethod(Yup.string, 'contactName', function yupName(errorMessage = '') {
    return this.test('contactName', errorMessage, function (value, config) {
        if (isNullOrUndefined(value) || value === '') return true;

        const regName = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ/,.,\-0-9\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]+$/;
        if (!regName.test(value.trim())) {
            return this.createError({path: config.path, message: errorMessage});
        }

        return true;
    });
});


const normalizeMapping = {
    'À': 'A',
    'Á': 'A',
    'Â': 'A',
    'Ã': 'A',
    'Ä': 'A',
    'Ç': 'c',
    'È': 'E',
    'É': 'E',
    'Ê': 'E',
    'Ë': 'E',
    'Ì': 'I',
    'Í': 'I',
    'Î': 'I',
    'Ï': 'I',
    'Ñ': 'n',
    'Ò': 'O',
    'Ó': 'O',
    'Ô': 'O',
    'Ö': 'O',
    'Ù': 'U',
    'Ú': 'U',
    'Û': 'U',
    'Ü': 'U',
    'à': 'a',
    'á': 'a',
    'â': 'a',
    'ã': 'a',
    'ä': 'a',
    'ç': 'c',
    'è': 'e',
    'é': 'e',
    'ê': 'e',
    'ë': 'e',
    'ì': 'i',
    'í': 'i',
    'î': 'i',
    'ï': 'i',
    'ñ': 'n',
    'ò': 'o',
    'ó': 'o',
    'ô': 'o',
    'ö': 'o',
    'ù': 'u',
    'ú': 'u',
    'û': 'u',
    'ü': 'u',
};

export const normalize = (str) => {
    if (isEmptyString(str)) return '';

    const ret = [];
    for (let i = 0, j = str.length; i < j; i++) {
        const c = str.charAt(i);
        if (normalizeMapping.hasOwnProperty(str.charAt(i)))
            ret.push(normalizeMapping[c]);
        else
            ret.push(c);
    }

    return ret.join('').toLowerCase();
}
